'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = storeRegistry;

var _filter = require('lodash/fp/filter');

var _filter2 = _interopRequireDefault(_filter);

var _flatMap = require('lodash/fp/flatMap');

var _flatMap2 = _interopRequireDefault(_flatMap);

var _forEach = require('lodash/fp/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _subscriptionStore = require('./subscriptionStore');

var _subscriptionStore2 = _interopRequireDefault(_subscriptionStore);

var _squasher = require('../utils/squasher');

var _squasher2 = _interopRequireDefault(_squasher);

var _cachedValue = require('../utils/cachedValue');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function flow(actions) {
    return function (value) {
        return actions.reduce(function (args, action) {
            return action(args);
        }, value);
    };
}
var getTopicSubscription = function getTopicSubscription(stores) {
    return flow([stores.getValue, function (store) {
        return store.getSubscription();
    }]);
};

var closeEmptyStores = flow([(0, _filter2.default)(function (store) {
    return store.isEmpty();
}), (0, _forEach2.default)(function (store) {
    store.closeConnection('no active connections');
})]);

var getUsedTopics = flow([(0, _filter2.default)(function (store) {
    return !store.isEmpty();
}), (0, _flatMap2.default)(function (store) {
    return store.getDataTopics();
})]);

function storeRegistry() {
    var currentSession = void 0;
    var didCloseHandler = void 0;
    var squashDictionary = (0, _cachedValue.dictionary)(_squasher2.default);
    var createSubscription = function createSubscription(topic) {
        var newSubscriptionStore = (0, _subscriptionStore2.default)(topic, currentSession, squashDictionary);
        if (didCloseHandler) {
            newSubscriptionStore.on('didClose', didCloseHandler);
        }
        return newSubscriptionStore;
    };
    var topicsDictionary = (0, _cachedValue.dictionary)(createSubscription);

    var createStream = getTopicSubscription(topicsDictionary);
    return {
        getStores: topicsDictionary.values,
        getTopics: topicsDictionary.keys,
        setSession: function setSession(session) {
            currentSession = session;
            topicsDictionary.values().forEach(function (store) {
                store.setSession(session);
            });
        },
        createStream: createStream,
        setCloseListener: function setCloseListener(handler) {
            didCloseHandler = handler;
            topicsDictionary.values().forEach(function (store) {
                store.off('didClose');
                store.on('didClose', handler);
            });
        },
        closeEmptyStores: flow([topicsDictionary.values, closeEmptyStores]),
        getUsedTopics: flow([topicsDictionary.values, getUsedTopics])
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/connector/storeRegistry.js
// module id = 1425
// module chunks = 1